import React from 'react'

const BitenProjelerLast = () => {
    return (
        <div className='py-10 px-5 md:py-10 md:px-20 md:pb-20'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-20'>
                <div>
                    <div className='flex items-end space-x-1 mb-2 pl-0.5'>
                        <h1 className='flex-none text-12 font-bold'>SANAYİ TESİSLERİ</h1>
                        <div className='h-px mb-1 w-full bg-black'></div>
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-2 text-12 md:gap-5'>
                        <div className='flex flex-col '>
                            <p>DOC AUTO CENTER</p>
                            <p>ABALIOĞLU YEM FABRİKASI KOCABAŞ</p>
                            <p>ABALIOĞLU YUMURTA FABRİKASI KOCABAŞ</p>
                            <p>ABALIOĞLU YUMURTA FABRİKASI MERSİN</p>
                            <p>ABALIOĞLU İDARİ BİNA İNŞAATI KOCABAŞ</p>
                            <p>ZORLU HOMETEKS TEKSTİL ÜRÜNLERİ SAN.A.Ş</p>
                            <p>ZORLU ENERJİ</p>
                            <p>ERPA DİYALİZ MERKEZİ</p>
                            <p>SÜLEYMAN TUĞRUL TARIM ÜRÜNLERİ İNŞ.NAK.PETROL.SAN.TİC.LTD.ŞTİ</p>
                            <p>ZAFER GÖKŞİN KİMYA TEKTİL SAN.VE TİC.A.Ş</p>
                            <p>MAKROTEKS TEKSTİL SAN.TİC.LTD.ŞTİ</p>
                            <p>AYSOY PAZARLAMA KONF.TEKSTİL SAN.VE A.Ş</p>
                            <p>DENİZ TEKSTİL SAN.TİC.AŞ</p>
                            <p>YAVUZÇEHRE TEKSTİL SAN.TİC.A.Ş</p>
                            <p>KÜP ŞARAPÇILIK FERM.GIDA SAN.TİC.LTD.ŞTİ</p>
                            <p>MENDERES TEKSTİL SAN.TİC.AŞ -YEMEKHANE</p>
                            <p>EKPEN TEKSTİL </p>
                            <p>HÜRSAN HAVLU</p>
                            <p>DALAMAN ORMAN ÜRÜNLERİ</p>
                            <p>ÇALIŞKAN SOBA TİC.LTD.ŞTİ</p>
                            <p>URGANCIOĞLU TEKSTİL SAN.TİC.LTD ŞTİ</p>
                            <p>ÜLKÜ MEYVECİLİK</p>
                            <p>ERİKOĞLU TEKSTİL</p>
                            <p>ALTINTOP KURUYEMİŞ </p>
                            <p>SHAMROCK TEKSTİL SAN.TİC.A.Ş</p>
                            <p>MODERN BETON SAN.TİC.AŞ</p>
                            <p>KESKİNOĞLU TAVUKÇULUK </p>
                            <p>USPAR TEKSTİL</p>
                            <p>ASLI TEKSTİL GİYİM SAN.TİC.A.Ş</p>
                            <p>DANTA PREFABRİK LTD.ŞTİ</p>
                            <p>COLOSAE  OTEL A.Ş</p>
                            <p>DEBAK DENİZLİ BAGALİT KALIP SAN.VE TİC.AŞ</p>
                            <p>DENİZ TEKSTİL SAN.TİC A.Ş</p>
                            <p>GÜÇSAN MAKİNA DOĞALGAZ SAN.VE TİC.LTD.ŞTİ</p>
                            <p>KIMIL TEKSTİL SAN.VE TİC.AŞ</p>
                            <p>LİDER PLASTİK SANAYİ TİC.AŞ</p>
                            <p>MAKROTEKS SAN.TİC.LTD.ŞTİ</p>
                            <p>MENDERES TEKSTİL SAN.TİC.AŞ</p>
                            <p>MEYTEKS TEKSTİL SAN.VE TİC.A.Ş</p>
                            <p>AMİROĞLU -AKBETON A.Ş</p>
                        </div>
                        <div>
                            <p>A.İHSAN -İBRAHİM ÖZBİLEN</p>
                            <p>AKTUR ARAÇ MUAYENE İSTASYONU</p>
                            <p>ALTINYAPRAK TEK.NAKIŞ SAN.VE TİC.LTD.ŞTİ</p>
                            <p>ARDÖKÜM MAKİNE VE MERDANE SAN.VE TİC.A.Ş</p>
                            <p>ASKON DEMİR ÇELİK SAN.TİC.AŞ</p>
                            <p>ATASANCAK ACIPAYAM TARIM İŞLETMESİ SAN.TİC.AŞ</p>
                            <p>BİKETEKS TEKSTİL KONF.SAN.VE TİC.AŞ</p>
                            <p>CEMETEKS SAN.TİC.LTD.ŞTİ</p>
                            <p>ÇAKAN KÖSELE DERİ SAN.TİC.LTD.ŞTİ</p>
                            <p>ÇALIŞKAN ISI CİHAZLARI SAN.VE TİC.LTD.ŞTİ</p>
                            <p>SANCAK NAKIŞ TEKS.SAN.VE TİC.LTD.ŞTİ</p>
                            <p>UĞURLULAR TEKSTİL SAN.A.Ş</p>
                            <p>ÜLKÜ MEYVECİLİK SAN.VE TİC.A.Ş</p>
                            <p>VURALLAR TEKSTİL SAN.TİC.LTD.ŞTİ</p>
                            <p>ÇAVUŞOĞLU TURİZM TİC.LTD.ŞTİ</p>
                            <p>TİNSAN RAF SİS.SAN.VE TİC</p>
                            <p>DİKİCİ SAN.TİC.LTD.ŞTİ</p>
                            <p>ELTEKSMAK MAK.SAN.TİC.LTD.ŞTİ</p>
                            <p>ESEN TEKSTİL SAN.TİC.LTD.ŞTİ</p>
                            <p>EVREN TEKSTİL SAN.TİC.LTD.ŞTİ</p>
                            <p>FERAHLI TEKSTİL SAN.TİC</p>
                            <p>GİRGİN TEKSTİL SAN.TİC.LTD.ŞTİ</p>
                            <p>YAKI TİCARET GIDA PAZARLAMA</p>
                            <p>GÖKÇE TEL SAN.VE TİC.LTD.ŞTİ</p>
                            <p>GÜRLESİN KARDEŞLER TEKS.SAN.VE TİC.LTD.ŞTİ</p>
                            <p>KALELİ PROFİL YAPI MAL.SAN.VE TİC.LTD.ŞTİ</p>
                            <p>KARACA TEKSTİL SAN.TİC.A.Ş</p>
                            <p>MAKSOMER İNŞ.SAN.TİC.A.Ş</p>
                            <p>MEGOFAN LTD.ŞTİ</p>
                            <p>NATUR TEKSTİL BOYA SAN.TİC.A.Ş</p>
                            <p>NOBEL TEKSİL SAN.TİC.A.Ş</p>
                            <p>ODABAŞI PLASTİK </p>
                            <p>OKUL KIRTASİYE KOLL.ŞTİ</p>
                            <p>ÖZSOYLAR KUYUMCULUK</p>
                            <p>SAĞLAM ECZA DEPOSU SAN.TİC.LTD.ŞTİ</p>
                            <p>NECDET ÖZER</p>
                            <p>TALAT ERDAT </p>
                            <p>MEHMET ÖKEN</p>
                            <p>HAKKI TEFENLİLİ</p>
                        </div>
                    </div>
                </div>


                <div>

                    <div className='grid grid-cols-1 md:grid-cols-2 text-12 gap-5'>
                        <div className='flex flex-col  space-y-6'>
                            <div>
                                <div className='flex items-end space-x-1 mb-2 pl-0.5'>
                                    <h1 className='flex-none text-12 font-bold'>OKULLAR</h1>
                                    <div className='h-px mb-1 w-full bg-black'></div>
                                </div>
                                <p>MERKEZEFENDİ BELEDİYESİ MERKEZ KÜTÜPHANESİ</p>
                                <p>İSTEK VAKFI OKULLARI -NESA EĞİTİM KURUMLARI A.Ş</p>
                                <p>ABALIOĞLU YEM SOYA A.Ş --40 DERSLİK OKUL-SEVİNDİK</p>
                                <p>ABALIOĞLU YEM SOYA A.Ş --40 DERSLİK OKUL-ŞİRİNKÖY</p>
                                <p>ABALIOĞLU YEM SOYA A.Ş --40 DERSLİK OKUL-ÜÇLER</p>
                                <p>ABALIOĞLU YEM SOYA A.Ş --40 DERSLİK OKUL-YENİŞEHİR</p>
                                <p>ABALIOĞLU YEM SOYA A.Ş-CEDİDE ABALIOĞLU İMAM HATİP LİSESİ</p>
                                <p>ABALIOĞLU YEM SOYA A.Ş-ABALIOĞLU ENDÜSTRİ MESLEK LİSESİ</p>
                                <p>AMİROĞLU İLKÖĞRETİM OKULU 18 DERSLİK</p>
                                <p>DERYA BALTALI OKUL-24 DERSLİK</p>
                                <p>SERVERGAZİ İLKÖĞRETİM OKULU</p>
                                <p>AHMET HULUSİ EFENDİ KÜLLİYE VE CAMİ</p>
                                <p>ATANUR CAMİ</p>
                            </div>

                            <div>
                                <div className='flex items-end space-x-1 mb-2 pl-0.5'>
                                    <h1 className='flex-none text-12 font-bold'>KONUTLAR</h1>
                                    <div className='h-px mb-1 w-full bg-black'></div>
                                </div>
                                <p>ARTI BİR ÇAMLIK KONUT KOOPERATİFİ</p>
                                <p>ARTI BİR FORUM KONUT KOOPERATİFİ</p>
                                <p>CANKURTARAN VİLLALARI İNŞAATI / FATİH PROFİL</p>
                                <p>HÜSEYİN KARADAVUT</p>
                                <p>KABAKLIOĞLU PROJESİ</p>
                                <p>KINIKLI APART EVLERİ</p>
                                <p>KORHAN DAYAN VİLLALAR</p>
                                <p>KÜP APART</p>
                                <p>NİLGÜN ÖK</p>
                                <p>S.S ALTIN KONUT YAPI KOOPERATİF</p>
                                <p>ŞİRİNKÖY VİLLALARI</p>
                                <p>TALAT ERDAT</p>
                                <p>VEDAT ERİKOĞLU</p>
                                <p>DEMOKRASİ (VİZE) KONUTLARI</p>
                                <p>YAŞAR ÇAĞLAR KONUT</p>

                            </div>

                        </div>
                        <div className='flex flex-col  space-y-6'>
                            <div>
                                <div className='flex items-end space-x-1 mb-2 pl-0.5'>
                                    <h1 className='flex-none text-12 font-bold'>BANKALAR</h1>
                                    <div className='h-px mb-1 w-full bg-black'></div>
                                </div>
                                <p>GARANTİ BANKASI A.Ş</p>
                                <p>HSBC BANKASI</p>
                                <p>MERKEZ BANKASI DENİZLİ ŞUBESİ (TADİLAT)</p>
                            </div>
                            <div>
                                <div className='flex items-end space-x-1 mb-2 pl-0.5'>
                                    <h1 className='flex-none text-12 font-bold'>ENERJİ TESİSLERİ</h1>
                                    <div className='h-px mb-1 w-full bg-black'></div>
                                </div>
                                <p>SANKO SANTRAL ENERJİ ÜRETİMİ SAN.TİC.A.Ş</p>
                                <p>TÜRKERLER İNŞ.TUR.MAD.ENERJİ ÜRETE.TİC.VE SAN.A.Ş</p>
                                <p>ZORLU DOĞAL ELEKTRİK ÜRETİM A.Ş</p>
                            </div>


                                                        <div>
                                <div className='flex items-end space-x-1 mb-2 pl-0.5'>
                                    <h1 className='flex-none text-12 font-bold'>GIDA TESİSLERİ</h1>
                                    <div className='h-px mb-1 w-full bg-black'></div>
                                </div>
                                <p>ABALIOĞLU YEM SOYA VE TEKSTİL SAN.A.Ş</p>
                                <p>AGRION TARIM GIDA SERACILIK</p>
                                <p>ALTINTOP KURUYEMİŞ GIDA SAN.TİC.LTD.ŞTİ</p>
                                <p>BİRİCİK ŞARAPÇILIK A.Ş</p>
                                <p>FRESHMAN GIDA ÜRÜNLERİ SAN.TİC.A.Ş</p>
                                <p>KESKİNOĞLU TAVUKÇULUK VE DAMIZLIK İŞİ A.Ş</p>
                                <p>KIRBIYIK KURUYEMİŞ GIDA </p>
                                <p>KÜP ŞARAPÇILIK FERM.GIDA SAN.TİC.LTD.ŞTİ</p>
                                <p>OSMAN AKÇA İNCİR İŞLETMELERİ</p>
                            </div>




                            <div>
                                <div className='flex items-end space-x-1 mb-2 pl-0.5'>
                                    <h1 className='flex-none text-12 font-bold'>HASTANELER</h1>
                                    <div className='h-px mb-1 w-full bg-black'></div>
                                </div>
                                <p>BEYAZİNCİ DİŞ HASTANESİ A.Ş</p>
                                <p>ODAK HASTANESİ A.Ş</p>
                                <p>PAMUKKALE ÜNİVERSİTESİ HASTANELERİ</p>
                                <p>PAMUKKALE ÜNİVERSİTESİ -1 GÖKŞİN ONKOLOJİ BİNASI</p>
                                <p>PAMUKKALE ÜNİVERSİTESİ -2 GEÇİŞ BLOĞU</p>
                                <p>VİZYON GÖZ A.Ş</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BitenProjelerLast